<div [class.dark-mode]="isDarkMode" [class.dark]="isDarkMode">

    <router-outlet ></router-outlet> 
</div>